import React from 'react'

export default function UpdateContract() {
  return (
    <div className='main'>UpdateContract</div>
  )
}
